export default __webpack_public_path__ + "cf3fc4ad6c10236dbb4fa510c89b83fe.svg";